import { Switch as HeadlessSwitch } from '@headlessui/react';
import React from 'react';

interface Props {
  enabled: boolean;
  setEnabled: (enabled: boolean) => void;
}

export default function Switch({ enabled, setEnabled }: Props) {
  return (
    <HeadlessSwitch
      checked={enabled}
      onChange={setEnabled}
      className="group inline-flex h-6 w-11 items-center rounded-full bg-dataops-primary-dark-blue/20 transition data-[checked]:bg-dataops-process-cyan"
    >
      <span className="size-4 translate-x-1 rounded-full bg-white transition group-data-[checked]:translate-x-6" />
    </HeadlessSwitch>
  );
}
